import Page from '../../components/page';
import { Grid } from './grid';

function TokenInfo() {
	// const [run, loading] = useAjax({
	// 	method: 'post',
	// 	url: '/api/auth/signIn',
	// 	data: {
	// 		USER_ACCOUNT: 'openapi001',
	// 		USER_PWD: '104104',
	// 	},
	// });

	// useEffect(() => {
	// 	run();
	// }, [run]);

	return (
		<Page>
			<Grid />
		</Page>
	);
}

export default TokenInfo;
